import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VentayaComponent } from './component/ventaya/ventaya.component';
import { VentayaRoutingModule } from './ventaya-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { MatRadioModule } from '@angular/material/radio';



@NgModule({
  declarations: [
    VentayaComponent
  ],
  imports: [
    CommonModule,
    VentayaRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ImportsModule
  ]
})
export class VentayaModule { }
